export enum FINANCIAL_PEOPLE_TYPE_ENUM {
  indicadorCliente = 1,
  indicadorFornecedor = 2,
  indicadorTerceirizado = 3,
  indicadorConcorrente = 4
}
